// Hub unique de la webapp, lié au client supabase, à sa session et au cycle
// de vie de l'onglet. Le code React passe par hooks/useBroadcast.ts.
import { supabase } from '../supabaseClient';
import {
    bindHubToAuth,
    bindHubToLifecycle,
    createBroadcastHub,
    type AuthLike,
    type BroadcastHub,
    type HubClient,
} from './broadcastHub';

let hub: BroadcastHub | null = null;

export function getBroadcastHub(): BroadcastHub {
    if (hub) return hub;
    hub = createBroadcastHub(supabase as unknown as HubClient, {
        log: (message, detail) => {
            if (import.meta.env.DEV) console.debug(`[realtime] ${message}`, detail);
        },
    });
    bindHubToAuth(hub, supabase.auth as unknown as AuthLike);
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
        bindHubToLifecycle(hub, window, document);
    }
    return hub;
}
